<template>
  <div class="mtn-30">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6 wow move-up">
        <div class="fun-fact--one mt-30 text-center">
          <h5 class="fun-fact__title">Große Reichweite</h5>
          <div class="fun-fact__count counter">
            <ICountUp
                :endVal="100000"
            />
          </div>
          <span class="fun-fact__text">Interessenten im Netzwerk</span>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 wow move-up">
        <div class="fun-fact--one mt-30 text-center">
          <h5 class="fun-fact__title">Vermittlungsrate</h5>
          <div class="fun-fact__count counter">
            <ICountUp
                :endVal="65"
            />
            %
          </div>
          <span class="fun-fact__text">der Vermittlungen verlaufen erfolgreich</span>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 wow move-up">
        <div class="fun-fact--one mt-30 text-center">
          <h5 class="fun-fact__title">Optimierungsquote</h5>
          <div class="fun-fact__count counter">
            <ICountUp
                :endVal="80"
            />
            %
          </div>
          <span class="fun-fact__text">der Bibliotheksstrukturen werden optimiert</span>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 wow move-up">
        <div class="fun-fact--one mt-30 text-center">
          <h5 class="fun-fact__title">Umschlagshäufigkeit</h5>
          <div class="fun-fact__count counter">
            <ICountUp
                :endVal="35"
            />
            %
          </div>
          <span class="fun-fact__text">Erhöhung der Umschlagshäufigkeit durch ein erweitertes Portfolio</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'

export default {
  name: 'FunFactOne',
  components: {
    ICountUp
  },
  data() {
    return {
      delay: 300,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.',
        decimal: ','
      }
    };
  }
};
</script>